import { render } from "./CTWalletPage.vue?vue&type=template&id=7dff2f3d&ts=true"
import script from "./CTWalletPage.vue?vue&type=script&lang=ts"
export * from "./CTWalletPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__